
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'


var LeaveApplyPage = Vue.extend({})
Vue.component('leaveApply-page', LeaveApplyPage)

export default {
  name: 'LeaveApplyPage',
  components: {
    XTable,
    Selector,
    CheckIcon,
    Flexbox,
    FlexboxItem,
    XInput,
    XTextarea,
    Group
  },
  data () {
    return {
      baseUrl: this.$store.state.url,
      flowId: '',
      info: {},
      leaveData: {},
      leaveTypeList: [],
      leaveType: '',
      specialHolidays: false,
      startDate: '',
      endDate: '',
      nowDate: '',
      leaveDay: '',
      dateDiffer: '',
      cause: '',
      explain: '',
      contactInformation: '',
      fileShowList: [], // 上传附件集合-预览
      uploadedFileIdList: [], // 已上传附件ID集合
      countLeaveDays: {}
    }
  },
  mounted () {
    // this.$emit('sendTitleToParent','借款申请');
    this.getLeaveTypeList()
    this.getModLeaveData()
  },
  props: {
    saveStatus: Number
  },
  methods: {
    async getModLeaveData () {
      let res = await this.axios({
        url: this.baseUrl + '/wechat/leave/modLeave',
        method: 'get'
      })
      this.info = res.data.form
      this.leaveData = res.data
    },
    async getLeaveTypeList () {
      let res = await this.axios({
        url: this.baseUrl + '/wechat/leave/types',
        method: 'get'
      })
      console.log(res)
      res.data.list.forEach((item) => {
        item.key = item.id
        item.value = item.name
        this.leaveTypeList.push(item)
      })
    },
    getLeaveType () {
      console.log(this.leaveType)
    },
    chooseStartDate () {
      let that = this
      this.$vux.datetime.show({
        cancelText: '取消',
        confirmText: '确定',
        format: 'YYYY-MM-DD HH:mm',
        minuteList: ['00', '15', '30', '45'],
        endDate: this.endDate,
        value: this.startDate,
        onConfirm (val) {
          that.startDate = val
          that.getDateDiffer()
        }
      })
    },
    chooseEndDate () {
      let that = this
      this.$vux.datetime.show({
        cancelText: '取消',
        confirmText: '确定',
        format: 'YYYY-MM-DD HH:mm',
        value: this.endDate,
        minuteList: ['00', '15', '30', '45'],
        startDate: this.startDate,
        onConfirm (val) {
          that.endDate = val
          that.getDateDiffer()
        }
      })
    },
    async getDateDiffer () {
      if (this.startDate != '' && this.endDate != '') {
        let res = await this.axios({
          url: this.baseUrl + '/wechat/leave/countLeaveDays?startTime=' + this.startDate + '&endTime=' + this.endDate,
          method: 'get'
        })
        if (res.data.status) {
          this.dateDiffer = res.data.leaveDay + '天 ' + res.data.leaveHour + '小时  共计' + res.data.leaveCountHour + '小时'
          this.countLeaveDays = res.data
        }
      }
    },

    chooseFile () { // 选择附件
      // let that = this;
      this.fileObj = document.getElementById('file').files
      // let fileL = document.getElementById('file').files.length;
      // for(let i=0;i<fileL;i++){
      //   let file = document.getElementById('file').files[i];
      //   let reader = new FileReader();
      //   reader.readAsDataURL(file);
      //   reader.onload=function(e) {
      //     that.fileShowList.push(this.result);
      //   }
      // }
      this.$vux.loading.show({
        text: '保存中'
      })
      this.submitFile()
    },
    deleteFile (index) { // 删除已选附件
      this.fileShowList.splice(index, 1)

      let deleteFileId = this.uploadedFileIdList[index]
      let fileData = new FormData()
      fileData.append('fileId', deleteFileId)

      this.axios({
        url: this.baseUrl + '/wechat/commonFile/deleteFile',
        method: 'post',
        data: fileData
      }).then((response) => {
        console.log('费用报销deleteFile', response)
        this.uploadedFileIdList.splice(index, 1)
      }).catch((response) => {
        this.$vux.loading.hide()
      })
    },
    async submitFile () { // 上传附件-图片
      let fileObjL = this.fileObj.length
      for (let i = 0; i < fileObjL; i++) {
        let fileData = new FormData()
        fileData.append('file', this.fileObj[i])
        fileData.append('taskId', this.info.id)
        fileData.append('refRecordId', this.leaveData.refRecordId)
        fileData.append('refModule', this.leaveData.refModule)
        // fileData.append("stepId",this.stepId);
        // fileData.append("operatorId",this.operatorId);
        // fileData.append("expenseType",this.info.type);
        // fileData.append('flowId', this.flowId)

        let res = await this.axios({
          url: this.baseUrl + '/wechat/commonFile/uploadFile',
          method: 'post',
          data: fileData
        })
        this.uploadedFileIdList.push(res.data.fileId)
      }
      let that = this
      let fileL = document.getElementById('file').files.length
      for (let i = 0; i < fileL; i++) {
        let file = document.getElementById('file').files[i]
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function (e) {
          that.fileShowList.push(this.result)
        }
      }
      this.$vux.loading.hide()
    },

    showMsg (msg) {
      this.$vux.alert.show({
        title: msg
      })
      setTimeout(() => {
        this.$vux.alert.hide()
      }, 2000)
    },
    saveForm () { // 保存
      if (this.leaveType == '' || this.startDate == '' || this.endDate == '' || this.cause == '') {
        this.showMsg('请补充必填信息')
        return false
      }
      this.$vux.loading.show({
        text: '加载中'
      })
      let formData = new FormData()
      formData.append('id', this.info.id)
      formData.append('fillDate', this.info.fillDate)
      formData.append('leaveTypeId', this.leaveType)
      formData.append('startTime', this.startDate)
      formData.append('endTime', this.endDate)
      formData.append('leaveDay', this.countLeaveDays.leaveDay)
      formData.append('leaveHour', this.countLeaveDays.leaveHour)
      formData.append('leaveCountHour', this.countLeaveDays.leaveCountHour)
      formData.append('leaveReason', this.cause)
      formData.append('handoverRemark', this.explain)
      formData.append('contactRemark', this.contactInformation)
      if (this.specialHolidays) {
        formData.append('isSpecial', '1')
      } else {
        formData.append('isSpecial', '0')
      }
      this.axios({
        url: this.baseUrl + '/wechat/leave',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        method: 'post',
        data: formData
      }).then((response) => {
        console.log('saveForm', response.data, this.saveStatus)
        if (response.data.status == 0) { // 保存失败
          console.log('保存失败')
          this.$vux.loading.hide()
          this.showMsg(response.data.msg)
        } else if (this.saveStatus == 0 && response.data.status == 1) { // 父组件操作发起，并且保存成功
          console.log('startFlow')
          this.startFlow()
        } else if (this.saveStatus == 1 && response.data.status == 1) { // 父组件操作提交，并且保存成功
          console.log('$emit')
          this.$emit('sendStatusToParent', { status: 1 })
          this.$vux.loading.hide()
        }
      }).catch((response) => {
        debugger
        this.$vux.loading.hide()
      })
    },
    startFlow () { // 发起
      let startData = new FormData()
      startData.append('id', this.info.id)
      this.axios({
        url: this.baseUrl + '/wechat/leave/startFlow',
        method: 'post',
        data: startData
      }).then((response) => {
        console.log('startFlow', response.data)
        this.showMsg('保存成功！请继续完成提交操作！')

        if (response.data.status == 1) {
          this.$emit('sendStatusToParent', {
            status: 0,
            id: response.data.taskId,
            stepId: response.data.stepId
          })
        }
        this.$vux.loading.hide()
      }).catch((response) => {
        this.$vux.loading.hide()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/launch/attendance/leaveApply.vue